import routerOptions0 from "/builds/skuby/e-shop-template/projects/web/node_modules/.bun/nuxt@4.3.1+a0ef9e983639d73c/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}